
/**
 * @param {?} dataPhoneNumber
 * @return {?}
 */
export function transformPhoneNumber(dataPhoneNumber: string): string {
  let /** @type {?} */ phoneNumber;

  if (dataPhoneNumber.substr(0, 1) === '0') {
    phoneNumber = dataPhoneNumber.substr(1, dataPhoneNumber.length - 1);
  } else if (dataPhoneNumber.substr(0, 2) === '62') {
    phoneNumber = dataPhoneNumber.substr(2, dataPhoneNumber.length - 1);
  } else {
    phoneNumber = dataPhoneNumber;
  }
  return phoneNumber;
}
